export default {
	main: {
        
	},
	order:{
		lines: [],
		total: 0
	}
}


// WEBPACK FOOTER //
// ./src/store/reducers/initialState.js